import {getCollabDocumentName, getYDocFromCache} from 'components/DSYS/editor/utils/collabProvider';

const HEADING_COLLAPSE_STATE_MAP = 'headingCollapseState';

const getCollapseStateMap = (collabId?: string) => {
  if (!collabId) {
    return undefined;
  }

  return getYDocFromCache(getCollabDocumentName(collabId))?.getMap<boolean>(
    HEADING_COLLAPSE_STATE_MAP
  );
};

export const getPersistedHeadingCollapsed = (
  collabId: string | undefined,
  headingId: string
): boolean | undefined => {
  const value = getCollapseStateMap(collabId)?.get(headingId);
  return typeof value === 'boolean' ? value : undefined;
};

export const setPersistedHeadingCollapsed = (
  collabId: string | undefined,
  headingId: string,
  collapsed: boolean
) => {
  getCollapseStateMap(collabId)?.set(headingId, collapsed);
};
